var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    fillRule: "nonzero",
    d: "M10 7.6c-1.325 0-2.4 1.075-2.4 2.4s1.075 2.4 2.4 2.4 2.4-1.075 2.4-2.4c-.016-1.319-1.081-2.384-2.4-2.4z",
    transform: "translate(-176 -363) translate(176 363)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    fillRule: "nonzero",
    d: "M10 4.3c-.917-.03-1.831.106-2.7.4-1.197.402-2.314 1.012-3.3 1.8C2.567 7.547 1.228 8.718 0 10l.5.5.5.5c2.6 2.6 5 4.7 9 4.7h.5s4.5.2 9.5-5.6c-2.4-2.7-5.6-5.8-10-5.8zm0 9.9c-1.699 0-3.23-1.023-3.88-2.593-.65-1.57-.291-3.376.91-4.577s3.008-1.56 4.577-.91C13.177 6.77 14.2 8.3 14.2 10c-.016 2.313-1.887 4.184-4.2 4.2z",
    transform: "translate(-176 -363) translate(176 363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z",
    transform: "translate(-176 -363) translate(176 363)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.26f5ee5e3d56e2a6197bbee353b004e8.svg";
export { ForwardRef as ReactComponent };